module.exports = __webpack_public_path__ + "static/media/ridel_logo_vector.69426f9b.svg";